import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "container px-0" }
const _hoisted_4 = { class: "row fv-row mb-2 mt-2" }
const _hoisted_5 = { class: "col-sm-6 col-md-3 mb-1" }
const _hoisted_6 = { class: "d-flex align-items-center position-relative" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-md-3 mb-1" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 col-md-3" }, null, -1)
const _hoisted_9 = { class: "col-sm-6 col-md-3 mb-1" }
const _hoisted_10 = { class: "d-flex align-items-center position-relative" }
const _hoisted_11 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_12 = { class: "card-body py-3" }
const _hoisted_13 = {
  key: 0,
  class: "row g-5"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  style: {"height":"150px","background":"grey"}
}
const _hoisted_17 = {
  class: "card-body px-1",
  style: {"padding-top":"10px !important","padding-bottom":"10px !important"}
}
const _hoisted_18 = { style: {"font-size":"12px"} }
const _hoisted_19 = { style: {"color":"blue"} }
const _hoisted_20 = { style: {"font-size":"10px"} }
const _hoisted_21 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("table", { class: "table align-middle gs-0 gy-4" }, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", {
        colspan: "6",
        style: {"text-align":"center"}
      }, "Tidak Ada Data")
    ])
  ])
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "row mt-5 mb-5" }
const _hoisted_25 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_26 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_27 = ["label", "value"]
const _hoisted_28 = { class: "p-3" }
const _hoisted_29 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_30 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.categoryId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categoryId) = $event)),
                  placeholder: "Pilih Kategori",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listCategory,
                  searchable: true,
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pilihKategori($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control w-250px ps-15",
                  placeholder: "Cari Nama",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
                  onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
                }, null, 544), [
                  [_vModelText, _ctx.name]
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.tableData.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-lg-2"
                }, [
                  _createElementVNode("div", {
                    class: "card card-stretch shadow mb-5 card-px-1",
                    onClick: ($event: any) => (
              _ctx.$router.push('/superadmin/daftar-product/detail/' + item._id)
            )
                  }, [
                    (item.imageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          alt: "file1",
                          class: "img-fluid",
                          style: {"height":"150px"},
                          src: _ctx.getImages(item.imgUrl)
                        }, null, 8, _hoisted_15))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16)),
                    _createTextVNode(" " + _toDisplayString(item.imgUrl) + " ", 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("h5", _hoisted_18, _toDisplayString(item.name), 1),
                      _createElementVNode("h4", _hoisted_19, "Rp. " + _toDisplayString(_ctx.formatPrice(item.price)), 1),
                      _createElementVNode("h5", _hoisted_20, "Stock " + _toDisplayString(item.stock), 1)
                    ])
                  ], 8, _hoisted_14)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23)),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_27))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("ul", _hoisted_30, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}